import {combineReducers} from 'redux'
import users from './users'
import messageCount from './messageCount'

export default combineReducers({
    users,messageCount
})